import forge from 'node-forge';

export const encyptionpublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuyl8bsUehjhZllA9YDal
0dxKpEFCxZIwq5jsd2evRxtnbftlfXApP4B7uKAVCyFxOZdVEk4Y/R/ijGzdCEgb
btiXYriRw3BJA8Vl6qLr6a/Z2Vr6lXJ5MdFx1QoYdqPvGsLip5v6s1mnAZ7lR6Pc
3FxeFDLu18A17Ohao2DerVxRdOqmvvQqdUTpHbovXyTFa1+9qus8ecOqS+TLPBpu
/Z8gp9NUbLllL6LS+6UIFOYDkanH9WN7axkZ5TpJCThcTlU/S8GGGE496MDyhZep
6/BjSoypJFAwvQEO7Hq8tZxRxRaWutSAyY6Jz+RKFB+Ka5vxWNxZi4kJ7AGDsoRu
LQIDAQAB
-----END PUBLIC KEY-----
`;

export function getRSAEncryptedString(string: string) {
    const publicKey = forge.pki.publicKeyFromPem(encyptionpublicKey);
    const encryptedBytes = publicKey.encrypt(string, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
    });

    const encryptedBase64 = forge.util.encode64(encryptedBytes);
    return encryptedBase64;
}
